define('item_relations_cell.tpl', ['Handlebars','Handlebars.CompilerNameLookup'], function(Handlebars, _nl_){
	return _wrap_fn_('item_relations_cell', {"compiler":[8,">= 4.3.0"],"main":function(container,depth0,helpers,partials,data) {
    return "<li><div data-type=\"backbone.collection.view.cell\"></div></li>  ";
},"useData":true}, 'extensions/SignalGroup/SignalGroupSearchSpringTheme/24.2.10/', 'extensions/SignalGroup/SignalGroupSearchSpringTheme/24.2.10/', Handlebars);
});